import conferenceDetails from './conference-details/conference-details.js';
import httpError from './http-error/http-error.js';
import loadingSpinner from './loading-spinner/loading-spinner.js';

let ComponentsModule = angular.module('conferences-components', [
    conferenceDetails,
    httpError,
    loadingSpinner
]).filter('trim', () => {
    return function(value) {
        if(!angular.isString(value)) {
            return value;
        }
        return value.trim();
    };
})
    .name;

export default ComponentsModule;



// WEBPACK FOOTER //
// ./src/app/angular/conferences.components.js